module.exports = {
          srcSet: __webpack_public_path__ + "35c4d0063f99cbb914989c9205ad5965-296.png"+" 296w",
          images:[ {path: __webpack_public_path__ + "35c4d0063f99cbb914989c9205ad5965-296.png",width: 296,height: 382}],
          src: __webpack_public_path__ + "35c4d0063f99cbb914989c9205ad5965-296.png",
          toString:function(){return __webpack_public_path__ + "35c4d0063f99cbb914989c9205ad5965-296.png"},
          
          width: 296,
          height: 382
        }